export class DomInfo {

  static scrollTop = 0;
  static mouseX = 0;
	static mouseY = 0;

}
